// import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'AppMain',
  components: {
    // Breadcrumb
  },
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};